function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import ListTableMetadataColsComponent from './ListTableMetadataColsComponent.vue';
import { GA_EVENTS } from '@/js/constants';
import { mapState } from 'vuex';
import { DEFAULT_TPL_COLUMNS, DEFAULT_TPL_FIELDS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA, ACCES_REQUEST_FILE_FORMAT, PATTERNS_VALIDATION } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
export default {
  name: 'FormAccessRequestTableComponent',
  components: {
    ListTableMetadataColsComponent: ListTableMetadataColsComponent
  },
  props: {
    tplToWork: {
      type: Object,
      required: true
    },
    isAudience: {
      type: Boolean,
      default: false
    },
    isAttributes: {
      type: Boolean,
      default: false
    },
    isProductivize: {
      type: Boolean,
      default: false
    },
    isCampaign: {
      type: Boolean,
      default: false
    },
    isSynapse: {
      type: Boolean,
      required: false,
      default: false
    },
    requestMessage: {
      type: String,
      required: false,
      default: ''
    },
    useCase: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      TYPE_FLOW: ACCESS_TYPE_FLOW.ACCESS,
      DEFAULT_TPL_COLUMNS: DEFAULT_TPL_COLUMNS,
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      ACCES_REQUEST_FILE_FORMAT: ACCES_REQUEST_FILE_FORMAT,
      defaultFields: null,
      columnFields: [],
      // response from Api
      columnFieldsLabels: [{
        key: 'column',
        sortable: true,
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Description',
        key: 'templateDisplayName',
        stickyColumn: true,
        isRowHeader: true
      }, {
        label: 'Required',
        key: 'include_in_flow'
      }],
      filter: null,
      filterOn: [],
      toSave: {},
      message: '',
      files: [],
      isLoading: false,
      isExternalUser: false,
      isServiceAccount: false,
      isDigitalAudience: false,
      externalUserType: null,
      externalUserOptions: [{
        value: 1,
        text: 'External User'
      }, {
        value: 2,
        text: 'Service Account'
      }, {
        value: 3,
        text: 'Digital Audience'
      }, {
        value: 4,
        text: 'Attributes'
      }, {
        value: 5,
        text: 'Productivize'
      }, {
        value: 6,
        text: 'Campaign'
      }],
      externalUserSynapse: [{
        value: 1,
        text: 'Usuario Externo'
      }, {
        value: 2,
        text: 'Entidad de servicio'
      }],
      benefited: '',
      businessCase: '',
      sandbox: null,
      alert: false,
      dismissCountDown: 0,
      dismissSecs: 5,
      inputUploadFile: null,
      select_all: false,
      key_request_table: 1,
      key_total_selected: 1,
      valid: true,
      interval: null,
      menu_calendar: null,
      sandboxes: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isAccessServiceAccountInput: function isAccessServiceAccountInput() {
      // return ACCESS_SERVICE_ACCOUNT_INPUT.some(record => utils.hasRole(record))
      return true;
    },
    dateFechaHasta: function dateFechaHasta() {
      return this.toSave.endDate;
    },
    rules: function rules() {
      var _this = this;
      return {
        endDate: [function (v) {
          return !!v || _this.translate('reglas.end_date');
        }],
        externalUserType: [function (v) {
          return !!v || _this.translate('reglas.external_user_type');
        }],
        clientEmail: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return PATTERNS_VALIDATION.EMAIL_GENERAL.test(v) || 'Ingrese un correo electrónico válido.';
        }],
        useCase: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        file: [],
        commentary: [function (v) {
          return !!v || _this.translate('reglas.field');
        }]
      };
    },
    filteredExternalUserOptions: function filteredExternalUserOptions() {
      return this.externalUserOptions.filter(function (option) {
        if (option.value === 6) {
          return userInfo && userInfo.orgs && userInfo.orgs[0] && userInfo.orgs[0].code === "074";
        }
        return true; // Muestra las demás opciones siempre
      });
    }
  }),
  created: function created() {
    var _this2 = this;
    // Separe defaultTemplate and Columnfields
    console.log("tpl", this.tplToWork);
    var separeValues = tasks.filterDefaultTableTagsAndColumnFields(this.tplToWork.objects.tags);
    this.defaultFields = separeValues.defaultFields;
    this.columnFields = separeValues.columnFields;

    // SET CHECKED DEFAULT COLUMNS
    this.columnFields.map(function (item) {
      var sensitiveField = item.fields[_this2.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
      var valueSencible = sensitiveField[_this2.DEFAULT_TPL_COLUMNS.SENSITIVE.type];
      if (!valueSencible) {
        sensitiveField.include_in_flow = _this2.ACCESS_TYPE_FLOW.INCLUDED;
      }
    });
    console.log("defaultfields", this.defaultFields);
    this.isExternalUser = this.tplToWork.item.isExternalUser || false;
    this.isServiceAccount = this.tplToWork.item.isServiceAccount || false;
    this.benefited = this.tplToWork.item.benefited || '';
    this.businessCase = this.tplToWork.item.business_case || '';
    this.sandbox = this.tplToWork.item.sandbox || null;

    // set save to send object
    this.toSave.applicant = window.userInfo.email;
    this.toSave.fields = this.tplToWork.objects.tags; // tags
    this.toSave.owner = this.defaultFields ? this.defaultFields[this.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue.toLowerCase() : null;
    this.toSave.relativeResourceName = this.tplToWork.item.relativeResourceName;
    this.toSave.table_id = this.tplToWork.item.tableReference.tableId;
    this.toSave.type_flow = this.TYPE_FLOW;
    this.toSave.tableReference = this.tplToWork.item.tableReference;
    this.toSave.endDate = this.tplToWork.endDate && utils.dateBrowserToService(this.tplToWork.endDate);
    this.toSave.index_node = this.tplToWork.item.index_node != null && this.tplToWork.item.index_node >= 0 ? this.tplToWork.item.index_node : -1;
    this.toSave.domain_table = this.tplToWork.item.domain_table;
    this.toSave.benefited = this.benefited;
    this.toSave.commentary = this.tplToWork.item.last_version && this.tplToWork.item.last_version.commentary ? this.tplToWork.item.last_version.commentary : '';
    this.toSave.isExternalUser = this.isExternalUser;
    this.toSave.isServiceAccount = this.isServiceAccount;
    if (this.isAudience) {
      this.isExternalUser = true;
      this.externalUserType = 3;
    }
    if (this.isAttributes) {
      this.isExternalUser = true;
      this.externalUserType = 4;
    }
    if (this.isCampaign) {
      this.isExternalUser = true;
      this.externalUserType = 6;
    }
    this.getSandboxes();
    if (this.isProductivize) {
      this.isExternalUser = true;
      this.externalUserType = 5;
      this.toSave.commentary = this.requestMessage;
      this.businessCase = this.useCase;
      var currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear() + 20);
      var twenty_years = "".concat(currentDate.getFullYear(), "-").concat(String(currentDate.getMonth() + 1).padStart(2, '0'), "-").concat(String(currentDate.getDate()).padStart(2, '0'));
      this.toSave.endDate = twenty_years;
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    onSelectUserType: function onSelectUserType(event) {
      console.log(this.externalUserType);
      // if (this.externalUserType == 3) {
      //   if (this.tplToWork.item.domain_table != window.userInfo.domain) {
      //     tasks.toast.error("No puede solicitar tablas de otro dominio para el uso en audiencias digitales.")
      //     return
      //   }
      // }
    },
    getSandboxes: function getSandboxes() {
      var _this3 = this;
      var companyCode = this.companyCode;
      var params = {
        user: window.userInfo.email,
        full: 1
      };
      UseCasesService.getUseCasesByCompanyCode(companyCode, {
        params: params
      }).then(function (response) {
        _this3.sandboxes = [];
        response.data.records.forEach(function (item) {
          _this3.sandboxes.push({
            id: item.id,
            name: item.business_name,
            technical_name: item.technical_name
          });
        });
      });
    },
    onSelectItem: function onSelectItem() {
      this.key_total_selected += 1;
    },
    getTotalSelected: function getTotalSelected() {
      var _this4 = this;
      if (this.tplToWork.tipo === "vista") {
        return this.tplToWork.item.columns_included.length;
      }
      return this.columnFields.filter(function (item) {
        return item.fields[_this4.DEFAULT_TPL_COLUMNS.SENSITIVE.name].include_in_flow == _this4.ACCESS_TYPE_FLOW.INCLUDED;
      }).length;
    },
    onSelectAll: function onSelectAll(event) {
      var _this5 = this;
      console.log(event);
      if (event) {
        this.columnFields.map(function (item) {
          var sensitiveField = item.fields[_this5.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
          sensitiveField.include_in_flow = _this5.ACCESS_TYPE_FLOW.INCLUDED;
        });
      } else {
        this.columnFields.map(function (item) {
          var sensitiveField = item.fields[_this5.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
          sensitiveField.include_in_flow = _this5.ACCESS_TYPE_FLOW.NOT_INCLUDED;
        });
      }
      this.key_request_table += 1;
    },
    onChangeExternalUser: function onChangeExternalUser() {
      this.isServiceAccount = false;
      this.benefited = '';
      this.businessCase = '';
      this.sandbox = null;
    },
    openImage: function openImage(url) {
      var uriObj = {
        name: 'DisplayImage',
        query: {
          uris: url
        }
      };
      var urlNew = this.$router.resolve(uriObj);
      window.open(urlNew.href, '_blank');
    },
    onSubmit: function onSubmit(event) {
      var _this6 = this;
      event.preventDefault();
      if (!this.$refs.form.validate()) return;
      // if (this.externalUserType == 3) {
      //   if (this.tplToWork.item.domain_table != window.userInfo.domain) {
      //     tasks.toast.error("No puede solicitar tablas de otro dominio para el uso en audiencias digitales.")
      //     return
      //   }
      // }
      if (!this.$refs.form.validate()) {
        var _iterator = _createForOfIteratorHelper(this.$refs.form.$children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var el = _step.value;
            if (el.valid === false) {
              el.focus();
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return;
      }
      var objectToRequest = this.toSave;
      var contador = 0;
      this.columnFields.map(function (item) {
        var sensitiveField = item.fields[_this6.DEFAULT_TPL_COLUMNS.SENSITIVE.name];
        if (sensitiveField.include_in_flow && sensitiveField.include_in_flow === _this6.ACCESS_TYPE_FLOW.INCLUDED) {
          contador = contador + 1;
        }
      });
      var isServiceAccount = false;
      switch (this.externalUserType) {
        case 2:
          isServiceAccount = true;
          break;
        case 3:
          isServiceAccount = true;
          break;
        case 4:
          isServiceAccount = true;
          break;
        case 6:
          isServiceAccount = true;
      }
      console.log(isServiceAccount);
      var extraParams = {
        files: this.files,
        isExternalUser: this.isExternalUser,
        isServiceAccount: isServiceAccount,
        isDigitalAudience: this.externalUserType == 3,
        isAttributes: this.externalUserType == 4,
        isProductivize: this.externalUserType == 5,
        isCampaign: this.externalUserType == 6,
        benefited: this.benefited,
        businessCase: this.businessCase,
        sandbox: this.sandbox
      };
      var params = {
        operator: objectToRequest.owner,
        type_flow: objectToRequest.type_flow,
        table_id: objectToRequest.table_id,
        relativeResourceName: objectToRequest.relativeResourceName,
        commentary: objectToRequest.commentary,
        fields: objectToRequest.fields,
        tableReference: objectToRequest.tableReference,
        endDate: objectToRequest.endDate,
        applicant: this.userEmail,
        extraParams: extraParams,
        index_node: objectToRequest.index_node,
        domain_table: objectToRequest.domain_table,
        source: this.tplToWork.item.source ? this.tplToWork.item.source : "bigquery"
      };
      if (!objectToRequest.owner || objectToRequest.owner == 'null' || objectToRequest.owner == undefined) {
        tasks.toast.warning("El objeto no tiene data operator o no se encuentra en entorno productivo.");
        return;
      }
      if (this.isExternalUser === true && !extraParams.isDigitalAudience && !extraParams.isAttributes && !extraParams.isProductivize) {
        if (extraParams.files.length === 0) {
          tasks.toast.error('If you want, register an external user. You must upload a file to the request');
          // this.$toast.warning('If you want, register an external user. You must upload a file to the request')
          return;
        }
      }
      if (contador > 0) {
        AssignmentsService.initApprovalFlow(params).then(function (response) {
          if (response.code === 200) {
            if (!response.success) {
              _this6.message = response.message;
              tasks.toast.error(_this6.message);
            } else {
              // close all modals
              _this6.$emit('submit', _this6.toSave);
              var fields_ = objectToRequest.fields[objectToRequest.fields.length - 1].fields;
              var type_flow = objectToRequest.type_flow;
              if (type_flow == "APPROVE_OWNER") {
                if (_this6.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.ASSIGN_OPERATOR,
                    object: 'table',
                    domain_object: objectToRequest.domain_table,
                    operator: _this6.stringToHash(objectToRequest.owner),
                    bdomain: fields_.domain.stringValue,
                    bsubdomain: fields_.subdomain.stringValue,
                    zone: fields_.zone.stringValue,
                    company_code: _this6.companyCode,
                    id_object: objectToRequest.tableReference.projectId + '.' + objectToRequest.tableReference.datasetId + '.' + objectToRequest.tableReference.tableId,
                    hash_email: _this6.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
              } else {
                console.log("event", GA_EVENTS[type_flow]);
                if (_this6.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS[type_flow],
                    object: 'table',
                    domain_object: objectToRequest.domain_table,
                    operator: _this6.stringToHash(objectToRequest.owner),
                    bdomain: fields_.domain.stringValue,
                    bsubdomain: fields_.subdomain.stringValue,
                    zone: fields_.zone.stringValue,
                    company_code: _this6.companyCode,
                    id_object: objectToRequest.tableReference.projectId + '.' + objectToRequest.tableReference.datasetId + '.' + objectToRequest.tableReference.tableId,
                    hash_email: _this6.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
              }
              tasks.toast.success('Successful request!');
              //this.$toast.success('Successful request!')
            }
          }
        });
      } else {
        tasks.toast.error('You must choose at least one row from the required column.');
        // this.$toast.warning('You must choose at least one row from the required column.')
      }
    },
    onCancel: function onCancel(event) {
      event.preventDefault();
      this.$emit('cancel', null);
    },
    onFileChange: function onFileChange(event) {
      var file = event.target.files[0];
      var fileReader = new FileReader();
      var self = this;
      if (!file || file === undefined) {
        return;
      }
      self.isLoading = true;
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: file.name
        };
        self.dismissCountDown = 0;
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || ''
            };
            self.files.push(_file);
          } else {
            self.showAlert();
          }
          self.isLoading = false;
          self.inputUploadFile = null;
        }).catch(function () {
          self.isLoading = false;
          self.showAlert();
          self.inputUploadFile = null;
        });
      };
      fileReader.readAsDataURL(file);
    },
    deleteFile: function deleteFile(record) {
      var _this7 = this;
      this.isLoading = true;
      if (record.fileId) {
        FilesService.deleteFile(record).then(function (res) {
          // if (res['success']) {
          //   const files = this.files
          //   this.files = files.filter(file => file.fileId !== record.fileId)
          //   this.isLoading = false
          // } else {
          //   alert(res['message'])
          // }
          var files = _this7.files;
          _this7.files = files.filter(function (file) {
            return file.fileId !== record.fileId;
          });
          _this7.isLoading = false;
        });
      }
    },
    showAlert: function showAlert() {
      this.alert = true;
      this.startCountdown();
    },
    startCountdown: function startCountdown() {
      var _this8 = this;
      clearInterval(this.interval);
      this.interval = setInterval(function () {
        _this8.dismissCountDown += 1;
        if (_this8.dismissCountDown >= _this8.dismissSecs) {
          _this8.alert = false;
          clearInterval(_this8.interval);
        }
      }, 1000);
    }
  },
  watch: {
    isExternalUser: function isExternalUser(val) {
      this.isExternalUser = val;
      this.toSave.isExternalUser = val;
    },
    isServiceAccount: function isServiceAccount(val) {
      this.isServiceAccount = val;
      this.toSave.isServiceAccount = val;
    },
    dismissCountDown: function dismissCountDown(value) {
      if (value < this.dismissSecs + 1) return;
      this.dismissCountDown = 0;
    }
  }
};